import React, { useEffect, useMemo } from 'react';

import { FormikValues, useFormik } from 'formik';

import {
  getBilling,
  IProfessionalBilling,
  professionalBillingInfo,
  updateBilling,
  userActions,
} from '@pharmaplan/common';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { BillingValidator } from '../../FormValidation';
import ProfileForm from '../../ProfileForm';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import { ProfileScreens } from '../../../../helpers/Constants';
import useDisableProfileSave from '../../../../hooks/useDisableProfileSave';

export interface ICommonProfile {
  setSelected: React.Dispatch<React.SetStateAction<string>>;
}

const Billing = ({ setSelected }: ICommonProfile) => {
  const dispatch = useAppDispatch();
  const billingInfo = useAppSelector(professionalBillingInfo);

  const { accountNumber } = billingInfo ?? {};
  const parsedNumber = accountNumber ? '*'.repeat(5).concat(accountNumber) : '';

  const handleSubmit = (values: FormikValues) => {
    dispatch(updateBilling(values as IProfessionalBilling));
  };

  const initialValues = useMemo(
    () =>
      ({
        ...billingInfo,
        isAccountNumberChanged: false,
        accountNumber: parsedNumber,
        isAnyDetailEntered: false,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [billingInfo],
  );

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
    enableReinitialize: true,
    validationSchema: BillingValidator(),
  });

  useEffect(() => {
    dispatch(getBilling());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEdit = () => {
    formik.setFieldValue('accountNumber', '');
    formik.setFieldValue('isAccountNumberChanged', true);
  };

  useEffect(() => {
    const isAnyDetailEntered = !!formik.values.accountNumber
      || !!formik.values.branchNumber
      || !!formik.values.institutionNumber;

    formik.setFieldValue('isAnyDetailEntered', isAnyDetailEntered);
    initialValues.isAnyDetailEntered = isAnyDetailEntered;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values]);

  const { disabled } = useDisableProfileSave({
    action: userActions.updateBilling,
    mutableValues: formik.values,
    initialValue: initialValues,
  });

  return (
    <ProfileForm
      selected={ProfileScreens.billing}
      setSelected={setSelected}
      handleEdit={handleEdit}
      disableSave={disabled}
      formik={formik}
    />
  );
};

export default Billing;
